var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "hovered-paths",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.584,2.189c-0.261-0.188-0.597-0.241-0.901-0.137l-17.73,5.91L19.229,4.027c-0.042-0.01-0.083,0.004-0.125,0  c-0.107-0.011-0.214-0.025-0.321-0.002l-18,4C0.326,8.127,0,8.532,0,9.001v43c0,0.304,0.138,0.59,0.375,0.78  c0.179,0.144,0.4,0.22,0.625,0.22c0.072,0,0.145-0.008,0.217-0.023l17.807-3.957l16.802,2.965c0.058,0.011,0.116,0.016,0.174,0.016  c0.121,0,0.24-0.024,0.352-0.066c0.003-0.001,0.007,0,0.01-0.002l18-7C54.747,44.783,55,44.413,55,44.001v-41  C55,2.679,54.846,2.378,54.584,2.189z M2,9.802l16-3.555v40.951L2,50.754V9.802z M20,6.263l15,3.529v40.016l-15-2.646V6.263z   M53,43.317l-16,6.222V9.721l16-5.333V43.317z",
    "data-original": "#000000",
    className: "hovered-path active-path",
    "data-old_color": "#000000",
    fill: "#646464"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map.fddab669.svg";
export { ForwardRef as ReactComponent };